export default {
  menu: 'Delivery Note',
  title: 'Delivery Note',

  general: {
    validators: {
      store: 'Warehouse not selected!',
      originStore: 'Source warehouse not selected',
      destinationStore: 'Destination warehouse not selected',
      valuesExist: 'This value is in the list',
      productExist: '{name} is in list',
      noProductChoose: 'No product selected',
      barcode: 'No product found with this barcode',
      price: 'The amount of goods has not been imported!',
      productCount: 'Inventory is not enough!',
      dynamicProductCount: '{name} inventory is not enough',
      quantity: 'The number of entered products is not valid!',
      description: 'Description field is empty!'
    },

    notifications: {
      insert: {
        success: 'Delivery note registered successfully',
        error: 'Delivery note registration was accompanied by an error!'
      },

      edit: {
        success: 'Delivery note updated successfully',
        error: 'Update delivery note was accompanied by an error!'
      },

      refreshStatus: {
        success: 'Delivery note status updated successfully',
        error: 'Update status of delivery note was accompanied by an error!'
      },

      delete: {
        success: 'Delivery note removed successfully',
        error: 'Delete delivery note was accompanied by an error!'
      },

      confirm: {
        success: 'Warehouse transfer confirmed successfully',
        error: 'Confirmation of warehouse transfer was accompanied by an error'
      }
    }
  },

  list: {
    title: 'Delivery Note',

    storeName: '{name} warehouse',

    table: {
      header: {
        id: 'Reference',
        creator: 'Creator',
        accountSide: 'Account side',
        invoiceId: 'Invoice ID',
        type: 'Type',
        approved: 'Status',
        createdAt: 'Registration Date'
      },

      filters: {
        type: {
          all: 'All',
          receive: 'Pull in',
          transfer: 'Transfer',
          deficit: 'Deficit',
          surplus: 'Surplus',
          conversion: 'Conversion',
          internalExit: 'Internal exit',
          internalReceipt: 'Internal receipt',
          exit: 'Pull out'
        },

        approved: {
          all: 'All',
          confirm: 'Confirmed',
          pending: 'pending'
        }
      }
    },

    receiptTypes: {
      receive: 'Pull in',
      transfer: 'Transfer',
      deficit: 'Deficit',
      surplus: 'Surplus',
      conversion: 'Conversion',
      internalExit: 'Internal exit',
      internalReceipt: 'Internal receipt',
      exit: 'Pull out'
    },

    statusTypes: {
      confirm: 'Confirmed',
      pending: 'pending'
    }
  },

  insert: {
    title: 'Add Delivery Note',

    labels: {
      type: 'Delivery note type',
      store: 'Warehouse',
      originStore: 'Source warehouse',
      destinationStore: 'Destination warehouse',
      registryDate: 'Registration Date',
      insertProduct: 'Add new product',
      first: 'first',
      second: 'second'
    },

    table: {
      header: {
        barcode: 'Barcode',
        name: 'Product',
        variant: 'Variable',
        count: 'Qty',
        unitPrice: 'Unit amount',
        totalPrice: 'Total amount',
        storeroom: 'Source warehouse',
        destinationStoreroom: 'Destination Warehouse',
        delete: 'Delete'
      }
    },

    receiptTypes: {
      receive: 'Pull in',
      transfer: 'Transfer',
      exit: 'Pull out'
    }
  },

  edit: {
    title: 'Edit Delivery Note'
  },

  receipt: {
    title: 'Delivery Note',
    dynamicTitle: '{name} Delivery Note',

    general: {
      labels: {
        user: 'Account side',
        supplier: 'Supplier',
        orderId: 'Order No',
        price: 'Price',
        registryDate: 'Registration Date',
        orderDate: 'Order Date',
        phoneNumber: 'Phone Number',
        type: 'Type',
        status: 'Status',
        note: 'Note',
        signature: 'Signature',
        receiverName: 'Receiver Name',
        senderName: 'Sender Name',
        print: 'Print',
        back: 'Back'
      },

      prompts: {
        noteDialog: {
          title: 'Customer Invoice Note'
        }
      },

      table: {
        header: {
          rowNumber: 'Row',
          image: 'Photo',
          code: 'Barcode',
          name: 'Description',
          store: 'Warehouse',
          originStore: 'Source warehouse',
          destinationStore: 'Destination warehouse',
          count: 'Qty',
          unitPrice: 'Unit amount',
          totalPrice: 'Total amount'
        }
      },

      validators: {
        count: 'The number {name} contradicts the number of this product in the invoice',
        scan: '{name} not scanned'
      },

      confirmation: {
        confirm: {
          title: 'Reference confirmation {name}',
          body: 'Are you sure about {name} the above delivery note?'
        },
        incomplete: {
          title: 'Not approved confirmation {name}',
          body: 'Are you sure about not approved the above delivery note?'
        },
        delete: {
          title: 'Delete confirmation {name} receipt',
          body: 'Are you sure about delete {name} receipt?'
        }
      },

      receiptTypes: {
        received: 'Pull in',
        transferred: 'Transferred',
        sended: 'Pull out',
        openingInventory: 'Opening inventory',
        receive: 'Pull in',
        transfer: 'Transfer',
        deficit: 'Deficit',
        surplus: 'Surplus',
        conversion: 'Conversion',
        internalExit: 'Internal exit',
        internalReceipt: 'Internal receipt',
        exit: 'Pull out'
      },

      receiptActions: {
        receive: 'Pull in',
        transfer: 'Transfer',
        exit: 'Pull out'
      },

      status: {
        confirm: 'Confirmed',
        notConfirm: 'not approved'
      }
    },

    postalLabel: {
      title: 'Postal label',
      dynamicTitle: 'Postal label sale invoice No. {number}',

      theme1: {
        orderNumber: 'Order No:',
        shipDate: 'Ship Date: ',
        customer: 'CUSTOMER: ',
        shipTo: 'SHIP TO: ',
        shipFrom: 'SHIP FROM: ',
        receiverInfo: 'SHIP TO INFO',
        senderInfo: 'SHIP FROM INFO',
        receiverName: 'Ship to name',
        senderName: 'Ship from name',
        address: 'Address',
        phoneNumber: 'Phone number',
        poBox: 'PO BOX ',
        callBeforeSend: 'Please call before sending',
        note: 'Note: ',
        insurancePrice: 'Insurance price'
      },

      theme2: {
        orderNumber: 'Order No: ',
        shipDate: 'Ship Date: ',
        customer: 'CUSTOMER: ',
        shipTo: 'SHIP TO: ',
        note: 'Note: ',
        shipFrom: 'SHIP FROM: ',
        poBox: 'PO BOX ',
        logesticSupport: 'Logistics Support: ',
        customerService: 'Customer Service: '
      },

      actions: {
        print: 'Print',
        back: 'Back'
      }
    },

    logs: {
      title: 'Delivery Note Logs'
    }
  },

  receiptConfirm: {
    table: {
      header: {
        rowNumber: 'Row',
        barcode: 'Barcode',
        name: 'Product',
        count: 'Qty',
        delete: 'Delete'
      }
    },

    validators: {
      notFound: 'No product found with this barcode',
      notExist: 'There is no product with this barcode in the invoice',
      noProductChoose: 'No products selected'
    },

    notifications: {
      insertProduct: {
        success: 'Number of items added'
      },

      dynamicInsertProduct: {
        success: 'Number { name } added'
      }
    }
  }
}
